// Librerias
import React from "react";
import moment from "moment";
moment.locale("es");
import api from "../../apiClient/v1";
// Componentes
import BlackBoxSemanal from "./BlackBoxSemanal";
import TablaAuditoriaSemanal from "./TablaAuditoriaSemanal.jsx";
import RowAuditoriaSemanal from "./RowAuditoriaSemanal.jsx";
import SelectRange from "../../components/shared/SelectRange.jsx";
const format = "YYYY-MM-DD";
import { ModalTrigger, ModalAuditorMasivo } from "./Modales.jsx";
import ResumenMensual from "./ResumenMensual.jsx";
import FacturacionMensual from "./FacturacionMensual.jsx";
import CheckboxSensores from "../../auditorias/programacion-semanal/CheckboxSensores.jsx";
import ReporteRuta from "./ReporteRuta.jsx";

class ProgramacionAISemanal extends React.Component {
  constructor(props) {
    super(props);
    this.blackbox = new BlackBoxSemanal();

    this.state = {
      idCliente: 0, // Seleccionar Todos por defecto
      numeroLocal: "",
      fechaInicialSeleccionada: moment().startOf("day"),
      fechaFinalSeleccionada: moment().endOf("day"),
      // Auditorias y Filtros
      filtros: {},
      auditoriasFiltradas: [],
      isLoading: false,
      loadingExcel: false
    };

    // referencia a todos las entradas de fecha de los inventarios
    this.rows = [];

  }
  componentWillMount() {
    // // al montar el componente, seleccionar el primer mes
    // this.seleccionarMes(this.state.meses[0].valor)
    this.buscarAuditorias();
  }
  componentWillReceiveProps(nextProps) {
    // cuando se reciben nuevos elementos, se generand posiciones "vacias" en el arreglo de rows
    this.rows = this.rows.filter((input) => input !== null);
  }

  focusRow(index, nombreElemento) {
    let ultimoIndex = this.rows.length - 1;
    if (index < 0) {
      // al seleccionar "antes de la primera", se seleciona el ultimo
      this.rows[ultimoIndex].focusElemento(nombreElemento);
    } else if (index > ultimoIndex) {
      // al seleccionar "despues de la ultima", se selecciona el primero
      this.rows[index % this.rows.length].focusElemento(nombreElemento);
    } else {
      // no es ni el ultimo, ni el primero
      this.rows[index].focusElemento(nombreElemento);
    }
  }

  // Select de Cliente seleccionado
  onSelectClienteChanged(evt) {
    this.setState(
      {
        idCliente: evt.target.value,
      },
      () => {
        this.buscarAuditorias();
      }
    );
  }
  onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal) {
    this.setState(
      {
        fechaInicialSeleccionada: momentumFechaInicio,
        fechaFinalSeleccionada: momentumFechaFinal,
      },
      () => {
        let fechaInicio =
          this.state.fechaInicialSeleccionada.format("YYYY-MM-DD");
        let fechaFinal = this.state.fechaFinalSeleccionada.format("YYYY-MM-DD");
        console.log(`rango seleccionado ${fechaInicio} al ${fechaFinal}`);
        // se llama al metodo seleccionar semana, que hace lo mismo
        this.buscarAuditorias(fechaInicio, fechaFinal);
      }
    );
  }

  // Filtros
  actualizarFiltro(nombreFiltro, filtro) {
    this.blackbox.reemplazarFiltro(nombreFiltro, filtro);
    // actualizar los filtros, y la lista ordenada de locales
    this.setState(this.blackbox.getListaFiltrada());
  }
  ordenarAuditorias(evt) {
    evt.preventDefault();
    this.blackbox.ordenarLista();
    this.setState(this.blackbox.getListaFiltrada());
  }

  // Llamadas al API
  // Todo: recibir el idCliente desde los metodos que lo llamen
  buscarAuditorias() {
    this.setState({ auditoriasFiltradas: [] });
    this.setState({ isLoading: true });
    let idCliente = this.state.idCliente;
    let fechaInicio = this.state.fechaInicialSeleccionada.format(format);
    let fechaFin = this.state.fechaFinalSeleccionada.format(format);
    console.log("Buscando auditorias...");
    api.auditoria
      .getPorRangoYCliente(fechaInicio, fechaFin, idCliente)
      .then((auditorias) => {
        //console.log(`auditorias del rango ${fechaInicio} a ${fechaFin}, y cliente ${idCliente}`, auditorias)
        this.blackbox.reset();
        auditorias.forEach((auditoria) => this.blackbox.add(auditoria));

        this.blackbox.ordenarLista();
        this.setState(this.blackbox.getListaFiltrada()); // {auditoriasFiltradas: ...}
        this.setState({ isLoading: false });
      });
  }
  guardarAuditoria(idAuditoria, formInventario) {
    console.log(formInventario)
    api.auditoria
      .actualizar(idAuditoria, formInventario)
      .then((auditoriaActualizada) => {
        console.log("auditoria actualizada correctamente", formInventario);
        // actualizar los datos y el state de la app
        this.blackbox.actualizarAuditoria(auditoriaActualizada);
        // actualizar los filtros, y la lista ordenada de locales
        this.setState(this.blackbox.getListaFiltrada()); // {auditoriasFiltradas: ...}
      });
  }
  eliminarAuditoria(auditoria) {
    if (this.props.puedeModificar !== true)
      return alert("No tiene los permisos para eliminar la Auditoria");

    console.log("eliminando ", auditoria);
    api.auditoria
      .eliminar(auditoria.aud_idAuditoria)
      .then((resp) => {
        this.blackbox.remove(auditoria.idAuditoria);
        // actualizar los filtros, y la lista ordenada de locales
        this.setState(this.blackbox.getListaFiltrada());
      })
      .catch((error) => console.error(error));
  }
  onSelectAuditorMasivoChanged(evt) {
    this.setState({
      idAuditorMasivo: evt.target.value,
    });
  }
  asignacionMasivaAuditor(cambiosAuditoria) {
    let promesasFetch = [];
    this.state.auditoriasFiltradas.forEach((auditoria) => {
      const data = {
        ...cambiosAuditoria,
        perecible: auditoria.aud_perecible ? 1 : 0
      }
      promesasFetch.push(
        api.auditoria.actualizar(auditoria.aud_idAuditoria, data)
      );
    });
    let request = Promise.all(promesasFetch)
      .then((auditorias) => {
        auditorias.forEach((res) => {
          this.blackbox.actualizarAuditoria(res);
        });
        this.setState(this.blackbox.getListaFiltrada());
      })
      .catch((auditorias) => {
        alert("error al actualizar las auditorias");
      });
    return request;
  }

  render() {
    let fechaInicial = this.state.fechaInicialSeleccionada.format(format);
    let fechaFinal = this.state.fechaFinalSeleccionada.format(format);
    return (
      <div>
        <div style={{display: "flex", justifyContent: 'space-between'}}>
          <h1>Programación Semanal AI</h1>
          {this.props.puedeVerExcelFacturacion && <ReporteRuta fechaInicio={this.state.fechaInicialSeleccionada}/>}
        </div>
        {this.props.puedeRevisarCliente ? (
          <div>
            {/* SELECTOR DE CLIENTE */}
            <div className={"col-sm-2 form-group "}>
              <label className="control-label" htmlFor="selectCliente">
                Cliente
              </label>
              <select
                className="form-control"
                name="selectCliente"
                ref={(ref) => (this.inputIdCliente = ref)}
                value={this.state.idCliente}
                onChange={this.onSelectClienteChanged.bind(this)}
              >
                <option value="0">Todos</option>
                {this.props.clientes.map((cliente, index) => {
                  return (
                    <option
                      key={index}
                      value={cliente.idCliente}
                    >{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
                  );
                })}
              </select>
            </div>
            {/* SELECTOR UN RANGO DE FECHAS */}
            <div className={"col-sm-3 form-group "}>
              <label className="control-label" htmlFor="selectSemana">
                Rango de Fecha
              </label>
              <SelectRange
                startDateSelected={this.state.fechaInicialSeleccionada}
                endDateSelected={this.state.fechaFinalSeleccionada}
                onInit={() => {
                  console.log("on init");
                }}
                onRangeSelected={this.onSelectRangoChanged.bind(this)}
              />
            </div>
          </div>
        ) : (
          <div>
            {/* SELECTOR DE CLIENTE */}
            <div className={"col-sm-2 form-group "}>
              <label className="control-label" htmlFor="selectCliente">
                Cliente
              </label>
              <select
                className="form-control"
                name="selectCliente"
                ref={(ref) => (this.inputIdCliente = ref)}
                value={this.state.idCliente}
                onChange={this.onSelectClienteChanged.bind(this)}
              >
                <option value="0">Todos</option>
                {this.props.clientes.map((cliente, index) => {
                  return (
                    <option
                      key={index}
                      value={cliente.idCliente}
                    >{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
                  );
                })}
              </select>
            </div>
            {/* SELECTOR UN RANGO DE FECHAS */}
            <div className={"col-sm-3 form-group "}>
              <label className="control-label" htmlFor="selectSemana">
                Rango de Fecha
              </label>
              <SelectRange
                startDateSelected={this.state.fechaInicialSeleccionada}
                endDateSelected={this.state.fechaFinalSeleccionada}
                onInit={() => {
                  console.log("on init");
                }}
                onRangeSelected={this.onSelectRangoChanged.bind(this)}
              />
            </div>
            {/* SELECTOR AUDITOR MASIVO */}
            <div className={"col-sm-2 form-group "}>
              <label className="control-label" htmlFor="selectCliente">
                Asignación múltiple
              </label>
              <select
                className="form-control"
                name="selectCliente"
                value={this.state.idAuditorMasivo}
                onChange={this.onSelectAuditorMasivoChanged.bind(this)}
              >
                <option value="">--</option>
                {this.props.auditores.map((auditor, index) => {
                  return (
                    <option
                      key={index}
                      value={auditor.id}
                    >{`${auditor.nombre1} ${auditor.apellidoPaterno}`}</option>
                  );
                })}
              </select>
            </div>
            <div className={"col-sm-1 form-group "}>
              <label className="control-label">&nbsp;</label>
              <div>
                <BotonAuditorMasivo
                  auditoriasFiltradas={this.state.auditoriasFiltradas}
                  idAuditorMasivo={this.state.idAuditorMasivo}
                  auditorMultiple={this.asignacionMasivaAuditor.bind(this)}
                  auditor={this.props.auditores.find(
                    (auditor) =>
                      auditor.id === parseInt(this.state.idAuditorMasivo)
                  )}
                />
              </div>
            </div>
          </div>
        )}
        <div style={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: 'space-between' }}>
          <CheckboxSensores
            nombre="Tipo Auditorias"
            filtro={this.state.filtros.filtroSensores || []}
            actualizarFiltro={this.actualizarFiltro.bind(
              this,
              "filtroSensores"
            )}
          />
          <div style={{ display: "flex", gap: "2px", maxWidth: "300px" }}>
            <div style={{ padding: '2px'}}>
              <a
                className="btn btn-info btn-xs"
                target="_blank"
                href={`/auditorias/detalles?cliente=${this.state.idCliente}&fechaInicio=${fechaInicial}&fechaFinal=${fechaFinal}`}
              >
                <span className="glyphicon glyphicon-list"></span> Detalles
              </a>
              <ResumenMensual />
            </div>
            <div style={{ padding: '2px'}}>
              <a
                className="btn btn-success btn-xs"
                href={`/auditorias/descargar-excel-por-rango?fechaInicial=${fechaInicial}&fechaFinal=${fechaFinal}&idCliente=${this.state.idCliente}`}
              >
                Exportar a Excel
              </a>
              {this.props.puedeVerExcelFacturacion && <FacturacionMensual />}
            </div>
          </div>
        </div>
        <TablaAuditoriaSemanal
          puedeRevisarCantidadMuestras={this.props.puedeRevisarCantidadMuestras}
          ordenarAuditorias={this.ordenarAuditorias.bind(this)}
          filtros={this.state.filtros}
          actualizarFiltro={this.actualizarFiltro.bind(this)}
        >
          {this.state.auditoriasFiltradas.length === 0 ? (
            <tr>
              <td colSpan="17" style={{ textAlign: "center" }}>
                <div
                  style={{
                    padding: "60px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.isLoading
                    ? "Cargando Auditorias..."
                    : "No hay auditorias para mostrar en este periodo."}
                </div>
              </td>
            </tr>
          ) : (
            this.state.auditoriasFiltradas.map((auditoria, index) => {
              let mostrarSeparador = false;
              let sgteInventario = this.state.auditoriasFiltradas[index + 1];
              if (sgteInventario)
                mostrarSeparador =
                  auditoria.aud_fechaProgramada !==
                  sgteInventario.aud_fechaProgramada;
              return (
                <RowAuditoriaSemanal
                  // Propiedades
                  puedeModificar={this.props.puedeModificar}
                  puedeRevisar={this.props.puedeRevisar}
                  puedeRevisarCantidadMuestras={
                    this.props.puedeRevisarCantidadMuestras
                  }
                  puedeVerExcelFacturacion={this.props.puedeVerExcelFacturacion}
                  key={auditoria.aud_idAuditoria}
                  index={index}
                  ref={(ref) => (this.rows[index] = ref)}
                  mostrarSeparador={mostrarSeparador}
                  auditoria={auditoria}
                  auditores={this.props.auditores}
                  // Metodos
                  guardarAuditoria={this.guardarAuditoria.bind(this)}
                  eliminarAuditoria={this.eliminarAuditoria.bind(this)}
                  focusRow={this.focusRow.bind(this)}
                  fcv={this.props.fcv}
                />
              );
            })
          )}
        </TablaAuditoriaSemanal>
      </div>
    );
  }
}

ProgramacionAISemanal.propTypes = {
  puedeModificar: React.PropTypes.bool.isRequired,
  puedeRevisar: React.PropTypes.bool.isRequired,
  puedeRevisarCliente: React.PropTypes.bool.isRequired,
  puedeRevisarCantidadMuestras: React.PropTypes.bool.isRequired,
  clientes: React.PropTypes.array.isRequired,
  auditores: React.PropTypes.array.isRequired,
};

export default ProgramacionAISemanal;
const BotonAuditorMasivo = ({
  auditoriasFiltradas,
  idAuditorMasivo,
  auditorMultiple,
  auditor,
}) => (
  <ModalTrigger>
    {(isVisible, showModal, hideModal) => (
      <button className="btn btn-md btn-success" onClick={showModal}>
        <span className={"glyphicon glyphicon-ok"}></span>
        {isVisible && (
          <ModalAuditorMasivo
            hideModal={hideModal}
            totalAuditorias={auditoriasFiltradas.length}
            auditorMultiple={auditorMultiple}
            idAuditorMasivo={idAuditorMasivo ? "" + idAuditorMasivo : ""}
            auditor={auditor}
          />
        )}
      </button>
    )}
  </ModalTrigger>
);



// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/ProgramacionAISemanal.jsx